import httpHelper from "../helpers/httpHelper";

const configApi = {
    get(data, languageCode) {
        return httpHelper.get("/Auth/Config/Get", data, {
            language: languageCode
        });
    },
    SiteMoocs(data) {
        return httpHelper.get("/Auth/Config/SiteMoocs", data);
    },
    ChangeLanguage(data) {
        return httpHelper.post("/Auth/Config/ChangeLanguage", data);
    }
}

export default configApi;
